<template>
  <div>
    <v-card class="card">
      <div class="container">
        <h1>MyBikeSetup</h1>
        <v-card-title v-html="$vuetify.t('$vuetify.home.title')"></v-card-title>

        <!--Hey du hast es geschafft auf die MyBikeSetup Web App zu kommen und was willst du jetzt hier?-->
        <v-card-text>
          <div v-html="$vuetify.t('$vuetify.home.mainmessage')"></div>
          <!--Neben unserer <a href="https://play.google.com/store/apps/details?id=net.byte_welt.eagleeye.mybikesetup" target="_blank">Android App</a> gibt es jetzt auch diese WebApp.<br>-->
          <!--Da wir, naja ich, aktuell nur noch die Android pfegen gibt es für alle anderen Plattformen diese WebApp. Wenn euer Browser mitspielt habt ihr die selben funktionen wie bei Google.-->
          <!--Ihr könnt hier eure Konfigurationen anlegen, bearbeiten und speichern, dabei werden alle Daten lokal in eurem Browser gespeichert. Browser zu, Browser auf und die Daten sind noch da (außer der Browser macht Mist und räumt auf, naaaa Apple 😜).-->
          <!--Außerdem sollte die App auch ohne Internetverbindung lauffähig sein, außer ihr habt einen Safari .... <br>-->
          <!--Aber ihr könnt wie bei Android auch die Daten aufm Server speichern lassen oder vom Android holen.-->
          <br>
          <br>
          <div v-if="isInitState(this.state)">
            <span v-html="$vuetify.t('$vuetify.home.initial_question')"></span>
            <!--Es gibt lokal keine Konfiguration, was soll passieren:<br>-->
            <!--Hast du schon eine User ID, dann gib sie hier ein-->
            <div class="section">
              <v-text-field v-model="uuid" label="User ID" :rules="inputRules" @keyup.enter="importBikes(uuid)"></v-text-field>
              <v-btn @click="importBikes(uuid)" v-html="$vuetify.t('$vuetify.home.components.load_configuration')"></v-btn>
            </div>
            <div class="create-area mt-2">
              <div class="create-text" v-html="$vuetify.t('$vuetify.home.noconfig_answer')"></div>
              <!--Du hast nichts? Dann lass dir hier eine Beispielkonfiguration erzeugen:-->
              <!--              <v-btn @click="createNewSettings" v-html="$vuetify.t('$vuetify.home.components.create_new')"></v-btn>-->
              <v-btn @click="createNewSettings" icon outline>
                <v-icon>build</v-icon>
              </v-btn>
            </div>
          </div>
          <div v-else v-html="$vuetify.t('$vuetify.home.existing_configmsg')">
            <!--Oh es gibt hier eine Konfiguration, na dann auf spiel rum.-->
          </div>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {eventBus} from '../main';

  const STORE_STATE = {INITIALIZED: 0, CLEAR: 1, UNSAVED: 2}

  export default {
    name: 'Home',
    data() {
      return {
        inputRules: [
          v => !!v || this.$vuetify.t('$vuetify.errormsg.required')
          /*, v => v.length >= 3 || $vuetify.t('$vuetify.errormsg.minlength')*/
        ],
        uuid: ''
      }
    },
    computed: {
      ...mapGetters(['state'])
    },
    methods: {
      ...mapActions(['createNewSettings', 'importBikes']),
      isInitState(state) {
        return state == STORE_STATE.INITIALIZED;
      },
    },
    mounted(e) {
      if (this.$route.params.uuid) {
        this.uuid = this.$route.params.uuid;
      }
      eventBus.$emit('title-change', '');
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    font-size: 40px;
  }

  .container {
    max-width: 768px;
    margin: 0 auto;
  }

  .v-card__text {
    text-align: left;
  }

  .section {
    display: flex;
  }

  .create-area {
    display: flex;
  }

  .create-text {
    margin-top: 10px;
  }

  @media (max-width: 500px) {
    .section {
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue